import React from "react";
import { Col, Row } from "react-bootstrap";
import { Skeleton } from "components";

export default function AdvancedSearchSkeleton() {
  return (
    <Row>
      <Col xs={12}>
        <Skeleton count={1} height={250} width={"100%"} className="mb-4" />
      </Col>
    </Row>
  );
}
